module.exports = __webpack_public_path__ + "static/media/flow-1.71765ae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/lifedash/src/flow-1.png
// module id = 210
// module chunks = 0